export default __webpack_public_path__ + "static/media/personal.81c921b7.png";